import React from 'react'
import SearchIcon from '@material-ui/icons/Search';
import {Button} from '@material-ui/core';
import messages from "./messages";
import useStyles, {_optionsStyle} from './styles'

export default function SearchButton(props){

    const classes = useStyles()
    const {id, defaultMessage: text} = messages
    const { disabled=false,
            onClick, size='medium',
            searchOptions,
            enableOptions=false,
            optionsStyle,
            ...wrapperProps
        } = props

    return (
        <div
            id={id}
            {...wrapperProps}
        >
            <Button
                id="MEDCAL_RX_SEARCH_BUTTON_BTN"
                className={classes.searchButton}
                onClick={onClick}
                color='primary'
                variant='contained'
                size={size}
                disabled={disabled}
                startIcon={<SearchIcon />}
                style={{maxWidth: 'fit-content'}}
            >
                {text}
            </Button>
            <div id='MEDCAL_RX_SEARCH_OPTIONS' style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
                { enableOptions && Object.keys(searchOptions).map( (option, i) => {
                    const fn = searchOptions[option]
                    return(
                        <span key={i}
                            className={fn ? classes.advSearchLink : classes.searchOption}
                            onClick={ fn ? fn(option, i) : null}
                        >
                            <span style={{..._optionsStyle, ...optionsStyle}}>
                                {option}
                            </span>
                        </span>
                    )
                })}
            </div>
        </div>
    )
}
